const BASE_ROUTE = '/stats';

export const STATS_ROUTES = {
  stats: BASE_ROUTE,
  products: `${BASE_ROUTE}/products`,
  payments: `${BASE_ROUTE}/payments`,
  acquisition: `${BASE_ROUTE}/acquisition`,
  shipping: `${BASE_ROUTE}/shipping`,
  liveview: `${BASE_ROUTE}/liveview`,
  coupons: `${BASE_ROUTE}/coupons`,
};
